import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { SliderWithTitle } from '@hivebrite/design-system/Slider';

import EventCard from 'hb-react/shared/apps/Events/components/EventsIndexContainer/components/EventCard';
import EventCardLoading from 'hb-react/shared/apps/Events/components/EventsIndexContainer/components/EventCardLoading';
import { useQueryTopicEvents } from 'hb-react/shared/apps/Topics/hooks/useQueryTopicEvents';
import useOutboxedFontTheme from 'hb-react/shared/hooks/theme/useOutboxedFontTheme';
import ThemeProvider from 'hb-react/style/ThemeProvider';

const EventsWrapper = ({ topic }) => {
  const navigate = useNavigate();
  const outboxedFontTheme = useOutboxedFontTheme();
  const { events, isLoading } = useQueryTopicEvents({
    enabled: topic.home_config.section_events_enabled,
  });

  if (!topic.home_config.section_events_enabled || events.length <= 3) {
    return null;
  }

  return (
    <ThemeProvider theme="fo" fontBrightness={outboxedFontTheme.fontBrightness}>
      <Box mb={2}>
        <Container data-testid="carousel-events">
          <SliderWithTitle
            title={topic.home_config.section_events_title || __('Events')}
            link={{
              url: '../events',
              text: __('See more'),
            }}
            items={events}
            total={events.length}
            ItemComponent={(event) => (
              <EventCard
                // @ts-expect-error: fix types
                event={event}
                onClick={() => {
                  navigate(Routes.network_event_path(event.id));
                }}
              />
            )}
            LoadingItemComponent={EventCardLoading}
            loading={isLoading}
            perPageBreakpoints={{
              s: 1,
              m: 2,
              l: 3,
              xl: 3,
            }}
          />
        </Container>
      </Box>
    </ThemeProvider>
  );
};

export default EventsWrapper;

const Container = styled(Box)`
  width: 100%;
  max-width: 1143px;
  margin: auto;
  position: relative;
  flex-direction: column;
`;
